<template>
    <div class="card">
        <div class="card-header">
        </div>
        <div class="card-body">
            <div class="row mt-15">
                <div class="col-md-6">
                    <download class="pull-left" :tableId="'p1s-analysis-result'" :fileName="'p1s-analysis-result'"></download>
                </div>
                <div class="col-md-6">
                </div>
            </div>
            <!-- ######## -->
            <!-- NEW TABLE -->
            <!-- ######## -->
            <div class="table-responsive app mb-15" v-dragscroll="true">
                <table id="p1s-analysis-result" class="table table-bordered app-inner" style="font-size: 11px;">
                    <thead v-if="tableFields.length > 0">
                        <tr>
                            <th class="align-middle" v-for="(lblObj, lIdx) in tableFields">{{ getLabel(lblObj.title) }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="tableFields.length > 0">
                        <tr v-for="(row, index, key) in rawData" v-bind:key="'row' + row + index">
                            <td v-for="(fieldObj, ind) in tableFields" v-bind:key="ind + '-td-' + index + key">
                                <span>
                                    <a v-if="fieldObj.sub_field == ''" class="a-btn">{{ row[fieldObj.field] }}</a>
                                    <a v-else class="a-btn">{{ row[fieldObj.field][fieldObj.sub_field] }}</a>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="rawData.length === 0">
                        <tr>
                            <td :colspan="tableFields.length">
                                <div class="alert alert-danger" role="alert">No data found!</div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <!-- ######## -->
            <!-- NEW TABLE -->
            <!-- ######## -->
            <!-- <div class="row mt-15">
                <div class="col-md-6">
                    <download class="pull-left" :tableId="'p1s-analysis-result'" :fileName="'p1s-analysis-result'"></download>
                </div>
                <div class="col-md-1" v-if="searchData.length > 0">
                    <download :tableId="'p1s-analysis-result'" :fileName="'p1s-analysis-result'"></download>
                </div>
                <div class="col-md-5">
                    <div class="pull-right">
                        <ul v-if="totalPages != 1" class="pagination">
                            <li :class="{ disabled: prevDisabled }" class="page-item">
                                <a class="page-link" @click.prevent="goToPage(1)" href="#">{{ '&lt;&lt;' }}</a>
                            </li>
                            <li :class="{ disabled: prevDisabled }" class="page-item">
                                <a class="page-link" @click.prevent="prev()" href="#">{{ '&lt;' }}</a>
                            </li>
                            <li v-for="page in pages" v-bind:key="page" class="page-item"
                                :class="(current_page == page) ? 'active' : ''">
                                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
                            </li>
                            <li :class="{ disabled: nextDisabled }" class="page-item">
                                <a class="page-link" href="#" @click.prevent="next()">{{ '&gt;' }}</a>
                            </li>
                            <li :class="{ disabled: nextDisabled }" class="page-item">
                                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{ '&gt;&gt;' }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import Datepicker from "vuejs-datepicker";

export default {
    components: { Datepicker },
    mixins: [commonMixins, pCommonMixins],
    props: ["cronList"],
    mounted() {
        console.log('mounted cronList', this.cronList);

    },
    created() {
        console.log('created cronList', this.cronList);
    },
    data() {
        return {
            ddate: new Date().setDate(new Date().getDate() - 1),
            tableFields: [
                { title: "Date", field: "date", sub_field: "" },
                { title: "Code", field: "co_code", sub_field: "" },
                { title: "Company Name", field: "company_name", sub_field: "" },
                { title: "Status", field: "status", sub_field: "" },
                { title: "Duration", field: "duration_seconds", sub_field: "" },
            ],
            rawDataApi: "frontend/profile_allocation_s1s_to_market/get",
            apiUrl: "",
            rawData: [],

            searchText: "",
            curYear: new Date().getFullYear(),
            minRange: [],
            maxRange: [],
            /* filterOptions: [
                {
                    id: 0,
                    value: "Pass",
                },
                {
                    id: 1,
                    value: "Fail",
                }
            ], */
            selFilter: [],
            selRangeFilter: 0,
            type: "s1",
            sectorData: [],
            sectorname: "",
            page: 1,
            perPage: 700,
            current_page: 1,
            pageToLoad: 1,
            totalPages: 1,
            prevDisabled: 1,
            nextDisabled: 0,
            pages: [],
            isDownload: 0,
            appTitle: "",
            dateFilterTabWiseData: [],
        };
    },
    methods: {
        prev() {
            this.pageToLoad = this.current_page - 1;
            this.fillTable();
        },
        goToPage(page) {
            this.pageToLoad = page;
            this.fillTable();
        },
        next() {
            console.log(this.$route.query);
            this.pageToLoad = this.current_page + 1;
            this.prevDisabled = 0;
            this.fillTable();
        },
        fillTable() {
            this.page = this.pageToLoad;
            if (this.pageToLoad == this.totalPages) {
                this.nextDisabled = 1;
            } else {
                this.nextDisabled = 0;
            }
            if (this.pageToLoad == 1) {
                this.prevDisabled = 1;
            } else {
                this.prevDisabled = 0;
            }
            this.current_page = this.pageToLoad;
            //this.getS1Data();
        },
        getDateData(e) {
            console.log("Date Selected", e);
            this.ddate = e;
            //this.getS1Data();
        },
        downloadAll() {
            this.isDownload = 1;
        }
    },
    watch: {
        cronList(value) {
            /* value.forEach((val, key) => {
              console.log('Object.keys:::', Object.keys(val));
              }); */
            console.log('watch cronList:::', value[0]);
            if (value[0] !== undefined) {
                console.log('watch value:::', value[0]);
                console.log('Object.keys:::', Object.keys(value[0]));
                this.rawData = value;
            } else {
                this.rawData = [];
            }
        },
        /* title(value) {
          this.appTitle = value;
        } */
    },
    computed: {
        /* filterOptions0: function () {
            return this.filterOptions.filter(function (row, index) {
                return row.id === "p11_actual";
            });
        },
        filterOptions1: function () {
            return this.filterOptions.filter(function (row, index) {
                return row.id === "q1_a_b_greater";
            });
        },
        filterOptions2: function () {
            return this.filterOptions.filter(function (row, index) {
                return row.id === "p11_quarterly_trends";
                // return row.id === "q1_S" || row.id === "q1_a_S" || row.id === "q1_b_S" || row.id === "q1_c_S" || row.id === "q1_d_S";
            });
        } */
    }
};
</script>
<style>
form .col-md-3 {
    width: 40%;
}

.table td {
    padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/p1-s-analysis-result.vue